<template>
<!-- Transcriber设置手动弹框 -->
  <el-dialog
    title=""
    :visible.sync="dialogMessage.show"
    width="600px"
    center
    :modal="false"
  >
    <div>
        {{$t('lang.autoSensingTips')}}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        size="small"
        class="cancelButton"
          @click="cancel"
      >{{ $t("lang.cancel") }}</el-button>
      <el-button
        size="small"
        type="primary"
        class="saveButton"
        @click="save"
      >{{ $t("lang.ConfirmBtn") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    dialogMessage: {
      type: Object
    }
  },
  methods: {
    cancel () {
      this.dialogMessage.show = false
    },
    // Transcriber设为手动
    save () {
      this.axios
        .post(Outil.getUrl('/transcriber/setTranscriber'), {
          programId: this.$BehaviorSyns.getProgramId(),
          setOn: true
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.$emit('updateAutoStatus', false)
            this.dialogMessage.show = false
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    }
  }

}
</script>

<style lang="less" scoped>
::v-deep.el-dialog__wrapper{
  // z-index: 3000;
  .el-dialog__header{
    height: 45px !important;
    line-height: 45px !important
  }
}
</style>
